import { setStoreTypeValues } from 'utils/setStoreTypeValues';

let types: any = {
  GET_HCC_REQUEST: '',
  GET_HCC_SUCCESS: '',
  GET_HCC_FAILURE: '',

  GET_MEMBER_HCC_AND_DIAGS_REQUEST: '',
  GET_MEMBER_HCC_AND_DIAGS_SUCCESS: '',
  GET_MEMBER_HCC_AND_DIAGS_FAILURE: '',

  GET_HCC_DETAILS_REQUEST: '',
  GET_HCC_DETAILS_SUCCESS: '',
  GET_HCC_DETAILS_FAILURE: '',

  UPDATE_HCC_STATUS_AND_COMMENT_REQUEST: '',
  UPDATE_HCC_STATUS_AND_COMMENT_SUCCESS: '',
  UPDATE_HCC_STATUS_AND_COMMENT_FAILURE: '',

  DELETE_HCC_DOC_REQUEST: '',
  DELETE_HCC_DOC_SUCCESS: '',
  DELETE_HCC_DOC_FAILURE: '',

};

types = setStoreTypeValues(types, 'eligibilityHCC');

export default types;
